import { styled } from 'styled-components';
const StyledIcon = styled.dt.withConfig({
  componentId: "aui__sc-j0ye5k-0"
})(["display:flex;align-items:center;justify-content:center;width:1.5rem;height:1.5rem;"]);
export { StyledIcon };